/* eslint-disable simple-import-sort/imports */
import Image from "next/image";
import Link from "next/link";
import { Badge } from "../ui/badge";
import { formatDate } from "@/lib/format-date";
import { Post } from "@/data/blog-posts";

interface CardPostProps {
  post: Post;
}

export const CardPostList = ({ post }: CardPostProps) => {
  return (
    <Link href={`/blog/${post.slug}`} className="group">
      <div className="bg-gradient-card grid grid-cols-1 items-stretch overflow-hidden rounded-lg border shadow-sm sm:grid-cols-[320px_1fr]">
        <div className="relative h-46 overflow-hidden sm:h-full lg:h-auto">
          <Image
            src={post.image || "/placeholder.svg"}
            alt={post.title}
            fill
            className="h-full flex-1 object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
            sizes="(max-width: 768px) 100vw, 320px"
          />
        </div>
        <div className="flex flex-col justify-center space-y-4 px-6 py-6 lg:space-y-2 lg:py-4">
          <div className="flex items-baseline gap-3 text-sm text-white/60">
            <Badge className="rounded-lg font-medium text-white">
              {post.category}
            </Badge>
          </div>
          <h3 className="line-clamp-2 text-base font-bold">{post.title}</h3>
          <span className="text-muted-foreground text-xs">
            {formatDate(post.publishedAt)}
          </span>
          <p className="text-muted-foreground mb-4 line-clamp-2 text-sm font-light md:text-base">
            {post.excerpt}
          </p>
        </div>
      </div>
    </Link>
  );
};
